import { CircularProgress } from "@mui/material";

export const Loader = () => <CircularProgress sx={{ marginTop: "32px" }} />;
